<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Albaranes</h2>
          <!--p class="text-purple-manax pl-3">Listado de Presupuestos</p-->
        </span>
        <span class="pull-right pt-1 pb-4 pr-3">

        </span>

        <table class="table table-hover m-0 align-top" stickyHeader stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">
                N°<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.number" placeholder="Buscar por N°…"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client" placeholder="Buscar por Cliente…"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" width="150px">
                Fecha Emisión<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dateStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.dateEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
              </th>
              <th class="d-none d-md-table-cell" width="1%"
                style="height: 65px; position: relative; max-width: 1000px;">
                Firmado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isSigned"
                  (ngModelChange)="getDeliveryNotes(true)" (click)="$event.stopPropagation()" style="max-width: 200px;">
                  <option [ngValue]="undefined"> todos </option>
                  <option [ngValue]="true"> Sí </option>
                  <option [ngValue]="false"> No </option>
                </select>
              </th>
              <th class="d-none d-md-table-cell" width="1%"
                style="height: 65px; position: relative; max-width: 1000px;">
                Facturado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isInvoiced"
                  (ngModelChange)="getDeliveryNotes(true)" (click)="$event.stopPropagation()" style="max-width: 200px;">
                  <option [ngValue]="undefined"> todos </option>
                  <option [ngValue]="true"> Sí </option>
                  <option [ngValue]="false"> No </option>
                </select>
              </th>
              <th class="d-none d-md-table-cell align-top text-right">
                Total {{curr}}<br>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                            <span>Filtros</span>
                          </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>

              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let deliveryNote of deliveryNotes" [class.text-danger]="deliveryNote.isDeleted"
              class='cursor-pointer' (click)="openDeliveryNote(deliveryNote)">

              <!-- PC -->
              <td class="d-none d-md-table-cell p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(deliveryNote._id)"
                      [checked]="selection.all || selection[deliveryNote._id]">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{deliveryNote.serieAndNumber}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote.client.lastname}} {{deliveryNote.client.firstname}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote.date | date:'dd/MM/yyyy'}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote.isSigned ? 'Sí': 'No'}}</td>
              <td class="d-none d-md-table-cell">{{deliveryNote.isInvoiced ? 'Sí': 'No'}}</td>
              <td class="d-none d-md-table-cell text-right">{{deliveryNote.total | money }}</td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-8 col-sm-6">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{deliveryNote.number ? deliveryNote.serieAndNumber : '' }} -
                          {{deliveryNote.client.firstname}} {{deliveryNote.client.lastname}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        Emisión: {{deliveryNote.date | date:'dd/MM/yyyy'}}
                      </div>
                      <div class="row pr-3">
                        Total: {{deliveryNote.total | money: { needSymbol:true } }}
                      </div>
                    </div>
                    <div class="col-4 col-sm-6 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row mb-2">
                        Firmado: {{deliveryNote.isSigned ? 'Sí': 'No'}}
                      </div>
                      <div class="row">
                        Facturado: {{deliveryNote.isInvoiced ? 'Sí': 'No'}}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openDeliveryNote(deliveryNote)">
                    <span>Abrir PDF</span>
                  </button>
                  <button mat-menu-item (click)="openTasksModal(deliveryNote.task)">
                    <span>Ver Trabajo</span>
                  </button>
                  <button mat-menu-item (click)="invoiceTask(deliveryNote.task)"
                    *ngIf="deliveryNote.task.status !== 'INVOICED'">
                    <span>Facturar</span>
                  </button>
                  <button mat-menu-item (click)="download(deliveryNote)">
                    <span>Descargar</span>
                  </button>
                  <button mat-menu-item (click)="sendEmail(deliveryNote)">
                    <span>Enviar por email</span>
                  </button>
                  <button mat-menu-item *ngIf="!deliveryNote.isSigned" (click)="requestSignature(deliveryNote)">
                    <span>Solicitar firma</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All  -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ deliveryNotes?.length }} albaranes</td>
            </tr>
          </tfoot>
        </table>
        <!-- </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>